import { createStore } from 'effector';
import { Accessory, Grass, Catnip, CatGrassSeeds } from '../../../model/products/Products.type';
import { fetchGetAllProductsFx } from './effects';

interface ProductsState {
  grasses: Grass[];
  accessories: Accessory[];
  catnips: Catnip[];
  catGrassSeeds: CatGrassSeeds[];
  error: string;
}

export const $productsState = createStore<ProductsState>({
  grasses: [],
  accessories: [],
  catnips: [],
  catGrassSeeds: [],
  error: '',
});

$productsState
  .on(fetchGetAllProductsFx.done, (state, { result }) => ({
    ...state,
    grasses: result.grasses,
    accessories: result.accessories,
    catnips: result.catnip,
    catGrassSeeds: result.catGrassSeeds,
  }))
  .on(fetchGetAllProductsFx.fail, (state, { error }) => ({
    ...state,
    error: error.message,
  }));

